<template>
  <div v-if="visible && data" class="fixed inset-0 z-50 bg-black bg-opacity-50 overflow-auto"
    @click.self="$emit('close')">
    <div class="a4-wrapper mx-auto mt-8 mb-8" ref="printArea">
      <!-- HEADER -->
      <div class="flex justify-between mb-4">
        <img src="@/assets/images/gspe.png" alt="Logo" class="h-24" />
      </div>

      <!-- KEPADA -->
      <div class="mb-4">
        <table>
          <tbody>
            <tr>
              <td style="width: 120px">No</td>
              <td>: {{ data.no }}</td>
            </tr>
            <tr>
              <td>Tanggal</td>
              <td>: {{ formatDate(data.date) }}</td>
            </tr>
            <tr>
              <td>Perihal</td>
              <td>: <strong>SURAT PERINTAH KERJA</strong></td>
            </tr>
            <tr>
              <td colspan="2">Kepada Yth</td>
            </tr>
            <tr>
              <td>Nama Subcon</td>
              <td>: {{ data.name }}</td>
            </tr>
            <tr>
              <td>Alamat</td>
              <td>
                <pre class="font-times">: {{ data.address }}</pre>
              </td>
            </tr>
            <tr>
              <td>No Telp</td>
              <td>: {{ data.phone }}</td>
            </tr>
            <tr>
              <td>No Fax</td>
              <td>: {{ data.fax }}</td>
            </tr>
            <tr>
              <td>Email</td>
              <td>: {{ data.email }}</td>
            </tr>
            <tr>
              <td>Attn</td>
              <td>: Bapak/Ibu {{ data.attn }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- PARAGRAF PEMBUKA -->
      <p class="mb-4">
        Dengan ini kami membuatkan Surat Perintah Kerja {{ data.name }} untuk pekerjaan Instalasi dan ATP dengan rincian
        biaya Instalasi dan ATP sebagai berikut :
      </p>

      <!-- TABEL DETAIL -->
      <table class="table-bordered mb-4">
        <thead>
          <tr>
            <th>No.</th>
            <th>Site</th>
            <th>Area</th>
            <th>Project</th>
            <th>Harga PO</th>
            <th>Mulai</th>
            <th>Waktu</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data.details" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.site }}</td>
            <td>{{ item.area }}</td>
            <td>{{ item.jobType }}</td>
            <td>Rp {{ Number(item.price).toLocaleString() }}</td>
            <td>{{ formatDate(item.startDate) }}</td>
            <td>{{ item.duration }} hari</td>
          </tr>
        </tbody>
      </table>

      <!-- REMARK & NOTE -->
      <p><strong>* Remark :</strong></p>
      <p class="mb-2">Install dan ATP</p>
      <p><strong>* Note :</strong></p>
      <ol class="pl-4 list-decimal space-y-1">
        <li>Satu minggu setelah instalasi, ATP harus dikirimkan ke GSPE</li>
        <li>ATP harus dilengkapi dg Foto, tanda tangan pihak Customer ( lengkap )</li>
        <li>Pengajuan invoice harus dilengkapi materai + ATP + No. NPWP + Alamat NPWP</li>
        <li>Report di email setiap hari max jam 4 sore</li>
        <li>Harga PO sudah termasuk biaya Instalasi dan ATP</li>
      </ol>

      <!-- PENUTUP & TTD -->
      <p class="mt-6">Demikian Surat Perintah Kerja (SPK) ini dibuat.</p>

      <div class="signature-area mt-6 text-sm">
        <div>
          <p>Mengetahui</p>
          <br /><br /><br />
          <p>({{ data.gspeuser }})</p>
        </div>
        <div>
          <p>Menerima</p>
          <br /><br /><br />
          <p>({{ data.attn }})</p>
        </div>
      </div>

      <!-- FOOTER ADDRESS -->
      <div class="footer-address">
        <div class="footer-column">
          <p>Intercon Plaza Blok D-11, Meruya Ilir</p>
          <p>Jakarta 11620, INDONESIA</p>
          <p>Telp. (62) (21) 584 5479, 586 8522/1,</p>
          <p>Fax. (62) (21) 585 3317</p>
        </div>

        <div class="footer-column">
          <p>Kawasan Industri Taman Tekno</p>
          <p>BSD Sektor XI C Kav C-11, Tangerang</p>
          <p>Telp. (62) (21) 7587-9949/51</p>
          <p>Fax. (62) (21) 7587-9952</p>
        </div>

        <div class="footer-column">
          <img src="@/assets/images/iso.png" alt="ISO Logo" class="iso-logo" />
        </div>
      </div>

      <!-- ACTION BUTTONS -->
      <div id="action-buttons-container" class="flex justify-end gap-2 mt-8">
        <button @click="print" class="bg-green-600 text-white px-4 py-2 rounded no-print">Print</button>
        <button @click="exportPDF" class="bg-blue-600 text-white px-4 py-2 rounded no-print">Export PDF</button>
      </div>
    </div>
  </div>
</template>

<script>
// Impor pustaka yang dibutuhkan
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// Impor logo Anda (pastikan path-nya benar)
import gspeLogo from '@/assets/images/gspe.png';
import isoLogo from '@/assets/images/iso.png';

export default {
  props: {
    visible: Boolean,
    data: Object
  },
  methods: {
    // Fungsi print biarkan apa adanya
    print() {
      window.print();
    },

    exportPDF() {
      if (!this.data) return;

      // --- 1. INISIALISASI DOKUMEN & VARIABEL ---
      const doc = new jsPDF('p', 'mm', 'a4');
      const pageHeight = doc.internal.pageSize.height;
      const margin = 15;
      let cursorY = margin;

      // --- FUNGSI FOOTER (Tidak diubah) ---
      const drawFooter = () => {
        const footerY = pageHeight - 35;
        // doc.setLineWidth(0.1);
        //doc.line(margin, footerY, 210 - margin, footerY);
        doc.setFontSize(8);
        doc.setFont('times', 'normal');
        const address1 = 'Intercon Plaza Blok D-11, Meruya Ilir\nJakarta 11620, INDONESIA\nTelp. (62) (21) 584 5479, 586 8522/1,\nFax. (62) (21) 585 3317';
        const address2 = 'Kawasan Industri Taman Tekno\nBSD Sektor XI C Kav C-11, Tangerang\nTelp. (62) (21) 7587-9949/51\nFax. (62) (21) 7587-9952';
        doc.text(address1, margin, footerY + 5);
        doc.text(address2, 85, footerY + 5);
        doc.addImage(isoLogo, 'PNG', 165, footerY + 5, 25, 15);
      };

      // --- DEKLARASI DATA TABEL DIPINDAHKAN KE ATAS (INI PERBAIKAN UTAMA) ---
      const tableHead = [['No.', 'Site', 'Area', 'Project', 'Harga PO', 'Mulai', 'Waktu']];
      const tableBody = this.data.details.map((item, index) => [
        index + 1, item.site, item.area, item.jobType,
        `Rp ${Number(item.price).toLocaleString('id-ID')}`,
        this.formatDate(item.startDate), `${item.duration} hari`
      ]);


      // --- 2. KONTEN UTAMA DENGAN URUTAN YANG BENAR & SPASI RINGKAS ---
      doc.addImage(gspeLogo, 'PNG', margin, cursorY, 60, 30);
      cursorY += 35; // Spasi setelah header

      doc.setFont('times', 'normal');
      doc.setFontSize(12);

      // Tabel Info SPK (yang pertama)
      autoTable(doc, {
        body: [
          ['No', `: ${this.data.no}`],
          ['Tanggal', `: ${this.formatDate(this.data.date)}`],
          ['Perihal', ': SURAT PERINTAH KERJA'],
        ],
        startY: cursorY,
        theme: 'plain',
        styles: { font: 'times', fontSize: 12, cellPadding: { top: 0, bottom: 0.5 } },
        columnStyles: { 0: { cellWidth: 30 } }
      });
      cursorY = doc.lastAutoTable.finalY + 3; // Spasi diringkas

      // Tabel Info Subcon (yang kedua)
      autoTable(doc, {
        body: [
          ['Kepada Yth', ''],
          ['Nama Subcon', `: ${this.data.name}`],
          ['Alamat', `: ${this.data.address}`],
          ['No Telp', `: ${this.data.phone}`],
          ['No Fax', `: ${this.data.fax}`],
          ['Email', `: ${this.data.email}`],
          ['Attn', `: Bapak/Ibu ${this.data.attn}`],
        ],
        startY: cursorY,
        theme: 'plain',
        styles: { font: 'times', fontSize: 12, cellPadding: { top: 0, bottom: 0.5 } },
        columnStyles: { 0: { cellWidth: 30 } }
      });
      cursorY = doc.lastAutoTable.finalY + 8; // Spasi diringkas

      // Paragraf Pembuka
      const lineHeight = 1.2;
      const openingText = `Dengan ini kami membuatkan Surat Perintah Kerja ${this.data.name} untuk pekerjaan Instalasi dan ATP dengan rincian biaya Instalasi dan ATP sebagai berikut :`;
      const splitText = doc.splitTextToSize(openingText, 180);
      doc.text(splitText, margin, cursorY, { lineHeightFactor: lineHeight });
      cursorY += (splitText.length * 4.5 * lineHeight); // Spasi diringkas

      // Tabel Detail Utama (sekarang variabelnya sudah ada)
      autoTable(doc, {
        head: tableHead,
        body: tableBody,
        startY: cursorY,
        theme: 'grid',
        styles: { font: 'times', cellPadding: 1.5, fontSize: 10 },
        headStyles: { fillColor: [220, 220, 220], textColor: 0, fontStyle: 'bold', font: 'times' },
        columnStyles: {
          0: { cellWidth: 8 },
          4: { cellWidth: 25, halign: 'right' },
          5: { cellWidth: 25 },
          6: { cellWidth: 15 },
        },
      });
      cursorY = doc.lastAutoTable.finalY + 8; // Spasi diringkas

      // Sisa konten (Remark, Note, TTD)
      const remainingContentHeight = 70;
      if (cursorY + remainingContentHeight > pageHeight - margin) {
        doc.addPage();
        cursorY = margin;
      }

      doc.setFont('times', 'normal');
      doc.setFontSize(10);
      doc.text('* Remark :', margin, cursorY);
      cursorY += 4;
      doc.text('Install dan ATP', margin, cursorY);
      cursorY += 8;
      doc.text('* Note :', margin, cursorY);
      cursorY += 4;
      const notes = [
        'Satu minggu setelah instalasi, ATP harus dikirimkan ke GSPE',
        'ATP harus dilengkapi dg Foto, tanda tangan pihak Customer ( lengkap )',
        'Pengajuan invoice harus dilengkapi materai + ATP + No. NPWP + Alamat NPWP',
        'Report di email setiap hari max jam 4 sore',
        'Harga PO sudah termasuk biaya Instalasi dan ATP',
      ];
      notes.forEach((note, index) => {
        const noteText = `${index + 1}. ${note}`;
        const splitNote = doc.splitTextToSize(noteText, 180);
        doc.text(splitNote, margin + 5, cursorY, { lineHeightFactor: 1.15 });
        cursorY += (splitNote.length * 3.5 * 1.15);
      });

      doc.setFontSize(12);
      cursorY += 8;
      doc.text('Mengetahui', margin, cursorY);
      doc.text(`(${this.data.gspeuser})`, margin, cursorY + 18);
      doc.text('Menerima', 130, cursorY);
      doc.text(`(${this.data.attn})`, 130, cursorY + 18);

      drawFooter();
      const spkNumber = this.data.no.replace(/\//g, '-'); // Ganti '/' dengan '-' agar aman untuk nama file
      const fileName = `${spkNumber}.pdf`;
      doc.save(fileName);
    },

    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return date.toLocaleDateString('id-ID', {
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      });
    }
  }
}
</script>

<style scoped>
.a4-wrapper {
  width: 210mm;
  min-height: 297mm;
  /* PENTING: Kembalikan baris ini */
  padding: 15mm;
  font-family: 'Times New Roman', Times, serif;
  font-size: 12px;
  background-color: white;
  color: #000;
  box-sizing: border-box;
}

.table-bordered {
  border-collapse: collapse;
  width: 100%;
}

.table-bordered th,
.table-bordered td {
  border: 1px solid #000;
  padding: 4px 6px;
  word-wrap: break-word;
}

/* Penting: Mencegah elemen-elemen ini terpotong di tengah halaman */
.signature-area,
.footer-address,
.table-bordered {
  page-break-inside: avoid;
}

.signature-area {
  display: flex;
  justify-content: space-between;
}

.footer-address {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 10px;
  margin-top: 40px;
  border-top: 1px solid #ccc;
  padding-top: 10px;
}

.footer-column {
  width: 33%;
}

.footer-column p {
  margin: 5px 0;
}

.iso-logo {
  height: 55px;
  width: auto;
  object-fit: contain;
}

.font-times {
  font-family: 'Times New Roman', Times, serif;
  white-space: pre-line;
}

/* Biarkan blok @media print apa adanya atau hapus, karena tidak terlalu berpengaruh ke html2pdf.js */
@media print {

  /* Sembunyikan semua elemen di luar area cetak */
  body>*:not(.print-modal-wrapper) {
    display: none;
  }

  /* Pastikan area cetak memenuhi halaman */
  .print-modal-wrapper,
  .a4-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    margin: 0;
    padding: 15mm;
    /* Pastikan padding sama dengan di layar */
    box-shadow: none;
    /* Hilangkan bayangan */
    width: 210mm;
    min-height: initial;
    /* Biarkan tinggi menyesuaikan konten */
  }

  /* Sembunyikan elemen yang tidak perlu dicetak (misal: tombol) */
  .no-print {
    display: none !important;
  }

  /* Paksa warna latar belakang dan teks agar tercetak (jika diperlukan) */
  .a4-wrapper {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>
